import * as React from "react";

function PlayStoreButton() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={162} height={48} fill="none">
			<path
				d="M0 5a5 5 0 015-5h152a5 5 0 015 5v38a5 5 0 01-5 5H5a5 5 0 01-5-5V5z"
				fill="#000"
			/>
			<path
				d="M81.763 26.102c-2.822 0-5.123 2.147-5.123 5.103 0 2.94 2.3 5.104 5.123 5.104 2.824 0 5.124-2.165 5.124-5.104 0-2.956-2.301-5.103-5.124-5.103zm0 8.198c-1.547 0-2.88-1.275-2.88-3.093 0-1.838 1.335-3.094 2.88-3.094 1.547 0 2.88 1.256 2.88 3.094 0 1.816-1.333 3.093-2.88 3.093zm-11.177-8.198c-2.822 0-5.122 2.147-5.122 5.103 0 2.94 2.3 5.104 5.123 5.104 2.823 0 5.123-2.165 5.123-5.104 0-2.956-2.3-5.103-5.123-5.103zm0 8.198c-1.546 0-2.88-1.275-2.88-3.093 0-1.838 1.335-3.094 2.88-3.094 1.547 0 2.88 1.256 2.88 3.094.002 1.816-1.333 3.093-2.88 3.093zM57.294 27.67v2.165h5.181c-.154 1.218-.56 2.107-1.18 2.725-.753.754-1.932 1.585-4.001 1.585-3.19 0-5.683-2.571-5.683-5.761s2.493-5.761 5.683-5.761c1.72 0 2.977.677 3.905 1.547l1.527-1.528c-1.296-1.237-3.015-2.184-5.432-2.184-4.37 0-8.042 3.557-8.042 7.926 0 4.37 3.673 7.926 8.042 7.926 2.358 0 4.138-.774 5.528-2.224 1.43-1.43 1.876-3.441 1.876-5.065 0-.501-.038-.966-.117-1.352h-7.287v.001zm54.369 1.681c-.424-1.14-1.72-3.248-4.369-3.248-2.629 0-4.814 2.069-4.814 5.103 0 2.861 2.166 5.104 5.065 5.104 2.339 0 3.692-1.43 4.254-2.262l-1.74-1.16c-.58.85-1.373 1.41-2.514 1.41-1.14 0-1.952-.521-2.474-1.546l6.824-2.822-.232-.579zm-6.96 1.702c-.057-1.973 1.528-2.977 2.669-2.977.889 0 1.643.445 1.895 1.082l-4.564 1.895zM99.155 36h2.241V20.999h-2.241v15.002zm-3.674-8.758h-.077c-.503-.6-1.47-1.141-2.687-1.141-2.552 0-4.891 2.243-4.891 5.124 0 2.86 2.339 5.084 4.89 5.084 1.219 0 2.185-.541 2.688-1.159h.077v.734c0 1.953-1.044 2.997-2.726 2.997-1.373 0-2.223-.985-2.571-1.817l-1.953.812c.56 1.353 2.049 3.016 4.524 3.016 2.63 0 4.853-1.547 4.853-5.317v-9.163h-2.126v.83h-.001zM92.91 34.3c-1.548 0-2.843-1.296-2.843-3.074 0-1.799 1.295-3.113 2.842-3.113 1.526 0 2.725 1.314 2.725 3.113 0 1.778-1.199 3.074-2.725 3.074zM122.166 21h-5.365v15h2.238v-5.683h3.126c2.482 0 4.922-1.796 4.922-4.658s-2.439-4.66-4.921-4.66zm.058 7.23h-3.185v-5.143h3.185c1.674 0 2.624 1.386 2.624 2.572 0 1.162-.95 2.57-2.624 2.57zm13.838-2.155c-1.621 0-3.3.714-3.995 2.297l1.988.83c.424-.83 1.216-1.101 2.046-1.101 1.158 0 2.335.695 2.354 1.93v.154c-.406-.231-1.274-.578-2.335-.578-2.142 0-4.324 1.177-4.324 3.377 0 2.007 1.757 3.3 3.725 3.3 1.505 0 2.335-.676 2.856-1.468h.077v1.158h2.162v-5.751c.001-2.662-1.988-4.148-4.554-4.148zm-.271 8.222c-.732 0-1.756-.368-1.756-1.275 0-1.158 1.275-1.602 2.375-1.602.983 0 1.447.213 2.045.502a2.714 2.714 0 01-2.664 2.375zm12.7-7.894l-2.567 6.504h-.077l-2.664-6.504h-2.412l3.995 9.09-2.278 5.057h2.335l6.158-14.147h-2.49zm-20.168 9.598h2.238V20.999h-2.238v15.002zM56.902 12.292c0 1.005-.298 1.806-.894 2.403-.677.71-1.56 1.066-2.645 1.066-1.04 0-1.924-.36-2.65-1.08-.727-.721-1.09-1.614-1.09-2.68s.363-1.96 1.09-2.68c.726-.72 1.61-1.08 2.65-1.08.516 0 1.01.1 1.477.3.47.202.845.47 1.126.805l-.633.633c-.476-.57-1.132-.854-1.971-.854-.759 0-1.414.266-1.967.8-.553.532-.83 1.224-.83 2.075 0 .851.277 1.543.83 2.076.553.533 1.208.8 1.967.8.804 0 1.475-.268 2.011-.805.348-.349.55-.835.604-1.458h-2.615v-.865h3.488c.036.189.052.37.052.544zM62.434 9.285h-3.278v2.282h2.956v.865h-2.956v2.283h3.278v.885H58.23V8.4h4.204v.885zM66.335 15.6h-.925V9.285h-2.011V8.4h4.947v.885h-2.011V15.6zM71.926 15.6V8.4h.925v7.2h-.925zM76.954 15.6h-.925V9.285h-2.011V8.4h4.947v.885h-2.011V15.6zM88.33 14.67c-.707.728-1.587 1.091-2.64 1.091-1.052 0-1.931-.363-2.638-1.09-.708-.728-1.06-1.618-1.06-2.67 0-1.053.352-1.944 1.06-2.67.707-.728 1.586-1.093 2.639-1.093 1.046 0 1.925.366 2.635 1.097.71.73 1.066 1.619 1.066 2.665 0 1.053-.354 1.943-1.061 2.67zm-4.595-.603c.533.54 1.184.809 1.956.809.771 0 1.424-.27 1.956-.81.533-.54.8-1.228.8-2.066 0-.837-.267-1.526-.8-2.066-.532-.54-1.185-.809-1.956-.809-.772 0-1.423.27-1.956.809-.532.54-.8 1.229-.8 2.066 0 .838.268 1.527.8 2.067zM90.69 15.6V8.4h1.126l3.499 5.6h.04l-.04-1.386V8.4h.925v7.2h-.966l-3.661-5.873h-.04l.04 1.388V15.6h-.923z"
				fill="#fff"
			/>
			<path
				d="M56.902 12.292c0 1.005-.298 1.806-.894 2.403-.677.71-1.56 1.066-2.645 1.066-1.04 0-1.924-.36-2.65-1.08-.727-.721-1.09-1.614-1.09-2.68s.363-1.96 1.09-2.68c.726-.72 1.61-1.08 2.65-1.08.516 0 1.01.1 1.477.3.47.202.845.47 1.126.805l-.633.633c-.476-.57-1.132-.854-1.971-.854-.759 0-1.414.266-1.967.8-.553.532-.83 1.224-.83 2.075 0 .851.277 1.543.83 2.076.553.533 1.208.8 1.967.8.804 0 1.475-.268 2.011-.805.348-.349.55-.835.604-1.458h-2.615v-.865h3.488c.036.189.052.37.052.544zM62.434 9.285h-3.278v2.282h2.956v.865h-2.956v2.283h3.278v.885H58.23V8.4h4.204v.885zM66.335 15.6h-.925V9.285h-2.011V8.4h4.947v.885h-2.011V15.6zM71.926 15.6V8.4h.925v7.2h-.925zM76.954 15.6h-.925V9.285h-2.011V8.4h4.947v.885h-2.011V15.6zM88.33 14.67c-.707.728-1.587 1.091-2.64 1.091-1.052 0-1.931-.363-2.638-1.09-.708-.728-1.06-1.618-1.06-2.67 0-1.053.352-1.944 1.06-2.67.707-.728 1.586-1.093 2.639-1.093 1.046 0 1.925.366 2.635 1.097.71.73 1.066 1.619 1.066 2.665 0 1.053-.354 1.943-1.061 2.67zm-4.595-.603c.533.54 1.184.809 1.956.809.771 0 1.424-.27 1.956-.81.533-.54.8-1.228.8-2.066 0-.837-.267-1.526-.8-2.066-.532-.54-1.185-.809-1.956-.809-.772 0-1.423.27-1.956.809-.532.54-.8 1.229-.8 2.066 0 .838.268 1.527.8 2.067zM90.69 15.6V8.4h1.126l3.499 5.6h.04l-.04-1.386V8.4h.925v7.2h-.966l-3.661-5.873h-.04l.04 1.388V15.6h-.923z"
				stroke="#fff"
				strokeWidth={0.2}
				strokeMiterlimit={10}
			/>
			<g filter="url(#prefix__filter0_ii)">
				<path
					d="M12.523 9.046c-.349.37-.555.943-.555 1.686V37.27c0 .744.206 1.316.555 1.686l.09.086 14.866-14.867v-.35L12.612 8.958l-.089.088z"
					fill="url(#prefix__paint0_linear)"
				/>
				<path
					d="M32.434 29.134l-4.955-4.957v-.351l4.956-4.956.112.064 5.871 3.336c1.677.953 1.677 2.511 0 3.465l-5.871 3.336-.113.063z"
					fill="url(#prefix__paint1_linear)"
				/>
				<g filter="url(#prefix__filter1_i)">
					<path
						d="M32.547 29.07L27.477 24 12.524 38.957c.552.585 1.466.657 2.494.074l17.53-9.961z"
						fill="url(#prefix__paint2_linear)"
					/>
				</g>
				<path
					d="M32.547 18.933l-17.53-9.96c-1.028-.585-1.942-.512-2.494.074L27.48 24.003l5.068-5.07z"
					fill="url(#prefix__paint3_linear)"
				/>
			</g>
			<defs>
				<linearGradient
					id="prefix__paint0_linear"
					x1={26.161}
					y1={10.451}
					x2={6.023}
					y2={30.589}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#00A0FF" />
					<stop offset={0.007} stopColor="#00A1FF" />
					<stop offset={0.26} stopColor="#00BEFF" />
					<stop offset={0.512} stopColor="#00D2FF" />
					<stop offset={0.76} stopColor="#00DFFF" />
					<stop offset={1} stopColor="#00E3FF" />
				</linearGradient>
				<linearGradient
					id="prefix__paint1_linear"
					x1={40.6}
					y1={24.001}
					x2={11.565}
					y2={24.001}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FFE000" />
					<stop offset={0.409} stopColor="#FFBD00" />
					<stop offset={0.775} stopColor="orange" />
					<stop offset={1} stopColor="#FF9C00" />
				</linearGradient>
				<linearGradient
					id="prefix__paint2_linear"
					x1={29.794}
					y1={26.754}
					x2={2.484}
					y2={54.064}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FF3A44" />
					<stop offset={1} stopColor="#C31162" />
				</linearGradient>
				<linearGradient
					id="prefix__paint3_linear"
					x1={8.757}
					y1={0.212}
					x2={20.952}
					y2={12.407}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#32A071" />
					<stop offset={0.069} stopColor="#2DA771" />
					<stop offset={0.476} stopColor="#15CF74" />
					<stop offset={0.801} stopColor="#06E775" />
					<stop offset={1} stopColor="#00F076" />
				</linearGradient>
				<filter
					id="prefix__filter0_ii"
					x={11.968}
					y={8.569}
					width={27.708}
					height={30.864}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={-0.15} />
					<feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
					<feBlend in2="shape" result="effect1_innerShadow" />
					<feColorMatrix
						in="SourceAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={0.15} />
					<feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
					<feBlend in2="effect1_innerShadow" result="effect2_innerShadow" />
				</filter>
				<filter
					id="prefix__filter1_i"
					x={12.523}
					y={24.001}
					width={20.023}
					height={15.433}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={-0.15} />
					<feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
					<feBlend in2="shape" result="effect1_innerShadow" />
				</filter>
			</defs>
		</svg>
	);
}

export default PlayStoreButton;
